export const Okta = (): JSX.Element => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 175 175'>
    <circle cx='85' cy='85' r='63' fill='none' stroke='#007ac7' strokeWidth='44' />
  </svg>
)
